import { useRapier, RigidBody } from "@react-three/rapier"
import { useFrame } from "@react-three/fiber"
import { useKeyboardControls } from "@react-three/drei"
import { useState, useEffect, useRef } from "react"
import * as THREE from "three"
import useGame from "./stores/useGame.js"

export default function Player() {

    const body = useRef()
    const [ subscribeKeys, getKeys ] = useKeyboardControls()
    const { rapier, world } = useRapier()
    const rapierWorld = world

    const [smoothedCameraPosition] = useState(() => new THREE.Vector3(10, 10, 10))
    const [smoothedCameraTarget] = useState(() => new THREE.Vector3())

    const start = useGame(state => state.start)
    const end = useGame(state => state.end)
    const restart = useGame(state => state.restart)

    const reset = () => {
        body.current.setTranslation({x:1.7, y:-3.5, z:-26})
        body.current.setLinvel({x:0, y:0, z:0})
        body.current.setAngvel({x:0, y:0, z:0})
    }

    useEffect(() => {
       const unsubscribeReset = useGame.subscribe(
            (state) => state.phase,
            (value) => {
                if (value === 'ready') {
                    reset()
                }
            }
        )

        const unsubscribeAny = subscribeKeys(() => {
            start()
        })

        return () => {
            unsubscribeReset()
            unsubscribeAny()
        }
    })
    useFrame((state, delta) => {
        const { forward, backward, leftward, rightward } = getKeys() 

        const impulse = { x: 0, y: 0, z: 0}
        const torque = { x: 0, y: 0, z: 0}

        const impulseStrength = 0.6 * delta
        const torqueStrength = 0.2 * delta

        if (forward) {
            impulse.z += impulseStrength
            impulse.x += torqueStrength
        }

        if (rightward) {
            impulse.x -= impulseStrength
            torque.z += torqueStrength
        }

        if (backward) {
            impulse.z -= impulseStrength
            impulse.x -= torqueStrength
        }

        if (leftward) {
            impulse.x += impulseStrength
            torque.z -= torqueStrength
        }

        body.current?.applyImpulse(impulse)
        body.current?.applyTorqueImpulse(torque)

        /**
         * camera
         */
        const bodyPosition = body.current?.translation()
        if (bodyPosition) {
            const cameraPosition = new THREE.Vector3()
            cameraPosition.copy(bodyPosition)
            cameraPosition.z -= 10
            cameraPosition.y += 5

            const cameraTarget = new THREE.Vector3()
            cameraTarget.copy(bodyPosition)
            cameraTarget.y += 4

            smoothedCameraPosition.lerp(cameraPosition, 5 * delta)
            smoothedCameraTarget.lerp(cameraTarget, 5 * delta)

            state.camera.position.copy(cameraPosition)
            state.camera.lookAt(cameraTarget)

            if (bodyPosition.z < -26 || bodyPosition.z > 28) {
                body.current.setTranslation({x:bodyPosition.x, y:bodyPosition.y, z:-26})
            }
        }
        

        // if (leftward || rightward || forward || backward) {
        //   console.log(bodyPosition)
        // }


    })

    return (
      <RigidBody
        ref={body}
        canSleep={false}
        colliders="ball"
        restitution={0.2}
        friction={1}
        linearDamping={2}
        angularDamping={2}
        position={[1.7, -3.5, -26]}
      >
        <mesh castShadow>
          <icosahedronGeometry args={[0.3, 1, 1]} />
          <meshStandardMaterial flatShading color="mediumpurple" />
        </mesh>
      </RigidBody>
    );
}